<template>
    <div>
        <changeRefining></changeRefining>
        <publishRefining></publishRefining>
    </div>
</template>

<script>

    import changeRefiningCss from './reportRefining.scss';
    import changeRefining from './changeRefining/index';
    import publishRefining from './publishRefining/index';
    export default {
        components:{
            changeRefining,
            publishRefining
        }
    }
</script>

<style scoped>

</style>